import { DownloadClinicalDocs } from '~/domain/usecases/clinicalDocs/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
  UnProcessableEntity,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

type Error = {
  code: string;
  detail: string;
  domain: string;
  title: string;
};

export class RemoteDownloadClinicalDocs implements DownloadClinicalDocs {
  private readonly url: string;

  private readonly httpClient: HttpClient<DownloadClinicalDocs.Model>;

  constructor(url: string, httClient: HttpClient<DownloadClinicalDocs.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  download = async (
    params: DownloadClinicalDocs.Params,
  ): Promise<DownloadClinicalDocs.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{docId}', params.docId.toString()),
      responseType: 'blob',
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.unprocessableEntity:
        throw new UnProcessableEntity('Parecer clínico não assinado');
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
